var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-subtitle-1 font-weight-light grey--text text--darken-2"},[_vm._v(_vm._s(_vm.text)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }